import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/layouts/default.vue").then(m => m.default || m)),
  tv: defineAsyncComponent(() => import("/home/runner/work/s02679-telenor-no/s02679-telenor-no/app/layouts/tv.vue").then(m => m.default || m))
}